import { fetchApiData } from '../FetchISR'

// Shared fetch helper with Next.js data cache support. Pass revalidate = 0 to
// bypass the data cache entirely (cache: 'no-store') for a live read.
const fetchCached = async (url, revalidate = 300) => {
  let data = null
  let error = null
  try {
    const res = await fetch(
      url,
      revalidate === 0 ? { cache: 'no-store' } : { next: { revalidate } },
    )
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    data = await res.json()
  } catch (err) {
    error = err?.message || 'Failed to fetch data'
    console.error(`Error fetching ${url}:`, err)
  }
  return { data, error, loading: false }
}

// The search API returns two shapes: a populated response is the raw paginated
// `{ count, results }`, while the "no properties available" branch wraps it as
// `{ status, code, message, data: { count, results } }`. Read results from both.
const extractSearchResults = (payload) =>
  payload?.results || payload?.data?.results || []

export const fetchHomePageProperties = async () => {
  const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/v2/vacation-rental/search/?page=1&page_size=8`

  // Short cache window. Previously 3600s, which froze the occasional 200
  // "No properties available" response on the homepage for a full hour.
  let response = await fetchCached(url, 300)
  let results = extractSearchResults(response?.data)

  // The endpoint intermittently returns an empty result set for this unfiltered
  // query (a transient upstream availability-sync gap). Never serve that empty
  // from cache — refetch live and prefer real results before rendering the
  // "Property Not Available" empty state.
  if (!results.length) {
    const fresh = await fetchCached(url, 0)
    const freshResults = extractSearchResults(fresh?.data)
    if (freshResults.length) {
      response = fresh
      results = freshResults
    }
  }

  return {
    ...response,
    data: {
      ...response?.data,
      data: results,
    },
  }
}

export const fetchPromoBanners = async () => {
  return fetchApiData(
    'promoBanners',
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/v2/vacation-rental/banner/`,
  )
}

export const fetchTrendingDestinations = async () => {
  return fetchApiData(
    'trendingDestinations',
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/v2/vacation-rental/trending-destination/city`,
  )
}

export const fetchHeroBanners = async () => {
  return fetchCached(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/v2/vacation-rental/hero-banner/`,
  )
}

export const fetchHappyGuestReviews = async (page = 1) => {
  return fetchApiData(
    'happyGuestReviews',
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/v2/vacation-rental/our-happy-guest/?page=${page}`,
  )
}
